import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdjusterReports = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21,
			r: 21,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 20.9961C23.7614 20.9961 26 18.7575 26 15.9961C26 13.2347 23.7614 10.9961 21 10.9961C18.2386 10.9961 16 13.2347 16 15.9961C16 18.7575 18.2386 20.9961 21 20.9961Z",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.211 24.7371L24.671 28.2771C24.531 28.4171 24.401 28.6771 24.371 28.8671L24.181 30.2171C24.111 30.7071 24.451 31.0471 24.941 30.9771L26.291 30.7871C26.481 30.7571 26.751 30.6271 26.881 30.4871L30.421 26.9471C31.031 26.3371 31.321 25.6271 30.421 24.7271C29.531 23.8371 28.821 24.1271 28.211 24.7371Z",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6992 25.2461C27.9992 26.3261 28.8392 27.1661 29.9192 27.4661",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4102 30.9961C12.4102 27.1261 16.2602 23.9961 21.0002 23.9961C22.0402 23.9961 23.0402 24.1461 23.9702 24.4261",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAdjusterReports;
